/* tp-journey (23.10.2026): experienta clientului cap-coada - tranzitii cu directie, foaie de marimi, eliminare din cos cu "Anuleaza",
   ecran de legatura spre plata, "Vazute recent", plutitoare care nu acopera continutul, subsol pliabil, filtrare animata.
   Se incarca dupa pagina; nu blocheaza nimic. Oprire: ?tps=0. Fiecare modul e izolat (safe) si nu modifica logica din tp-app-ui.js. */
(function () {
  'use strict';
  if (window.__tpj) return;
  window.__tpj = 1;
  if (/[?&]tps=0(&|$)/.test(location.search)) return;
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMQ = window.matchMedia ? matchMedia('(max-width: 767px)') : { matches: false };
  function safe(f) { try { return f(); } catch (e) { return undefined; } }
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function el(tag, cls, html) { var n = doc.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function handleOf(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : null; }
  function buzz(p) { safe(function () { if (navigator.vibrate && navigator.userActivation && navigator.userActivation.hasBeenActive) navigator.vibrate(p); }); }
  function hash(s) { var h = 5381, i; for (i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; return (h >>> 0).toString(36); }
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2.4"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

  function start() {
  /* spre plata nu facem tranzitie de pagina: ecranul de legatura se ocupa, iar checkout-ul Shopify nu o accepta */
  safe(function () { window.addEventListener('pageswap', function (e) { safe(function () { if (e.viewTransition && e.activation && e.activation.entry && /^\/checkouts?(\/|$)/.test(new URL(e.activation.entry.url).pathname)) e.viewTransition.skipTransition(); }); }); });
  /* bara de jos: tranzitia intre "file" ramane o aparitie simpla (fara glisare) */
  safe(function () { doc.addEventListener('click', function (e) { var a = e.target && e.target.closest ? e.target.closest('.tp-mobile-nav a') : null; if (a) safe(function () { sessionStorage.setItem('tpj_tab', '1'); }); }, true); });
  /* ====================================================================== */
  /* 1. PLUTITOARE: se retrag la derulare in jos, revin la derulare in sus    */
  /* ====================================================================== */
  safe(function () {
    var last = window.scrollY || 0, idle = 0, ticking = false;
    function upd() {
      ticking = false;
      var y = window.scrollY || 0, dy = y - last;
      if (Math.abs(dy) < 7) return;
      last = y;
      if (dy > 0 && y > 160) { root.classList.add('tpj-down'); clearTimeout(idle); idle = setTimeout(function () { root.classList.remove('tpj-down'); }, 1300); }
      else if (dy < 0) { root.classList.remove('tpj-down'); clearTimeout(idle); }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
  });

  /* ====================================================================== */
  /* 2. MARIME LIPSA: scuturare + defilare la alegerea marimii; foaie de marimi pe telefon */
  /* ====================================================================== */
  safe(function () {
    var prod = $('[data-tp-product]');
    if (!prod) return;
    var si = Number(prod.dataset.tpSizeIndex);
    var grp = si >= 0 ? $('[data-tp-option-index="' + si + '"]', prod) : null;
    var form = $('[data-tp-product-form]', prod);
    var sel = $('[data-tp-native-variants]', prod);
    if (!grp || !form) return;

    function nudge() {
      var r = grp.getBoundingClientRect();
      var navH = parseInt(getComputedStyle(root).getPropertyValue('--tp-app-nav-height'), 10) || 64;
      if (r.top < 70 || r.bottom > innerHeight - navH - 30) grp.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      grp.classList.remove('tpj-shake'); void grp.offsetWidth; grp.classList.add('tpj-shake');
      setTimeout(function () { grp.classList.remove('tpj-shake'); }, 900);
      buzz([14, 40, 14]);
    }
    var err = $('[data-tp-form-error]', form);
    if (err && window.MutationObserver) {
      new MutationObserver(function () { if (!err.hidden && /mărime|marime/i.test(err.textContent || '')) nudge(); })
        .observe(err, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
    }

    /* foaie de marimi: doar pe telefon, doar cand nu e aleasa nicio marime */
    var sheet = null, bypass = false;
    function chipsHtml() {
      return $$('label.tp-option-choice', grp).map(function (lb) {
        var inp = $('input', lb), v = ($('span', lb) || lb).textContent.trim();
        return '<button type="button" class="tpj-chip' + (inp.disabled ? ' is-off' : '') + (inp.checked ? ' is-on' : '') + (lb.classList.contains('tpj-last') ? ' tpj-last' : '') + '" data-v="' + v.replace(/"/g, '') + '"' + (inp.disabled ? ' disabled aria-disabled="true"' : '') + ' role="radio" aria-checked="' + (inp.checked ? 'true' : 'false') + '">' + v + '</button>';
      }).join('');
    }
    function paint() {
      var cta = $('.tpj-cta', sheet), on = $('.tpj-chip.is-on', sheet);
      cta.disabled = !on;
      cta.textContent = on ? 'Adaugă în coș · Mărimea ' + on.dataset.v : 'Alege o mărime';
    }
    function closeSheet(after) {
      if (!sheet || !sheet.open) { if (after) after(); return; }
      var done = function () { sheet.classList.remove('is-closing'); sheet.close(); root.classList.remove('tpj-lock'); if (after) after(); };
      if (reduce) return done();
      sheet.classList.add('is-closing'); setTimeout(done, 250);
    }
    function openSheet() {
      if (!sheet) {
        sheet = el('dialog', 'tpj-sheet');
        sheet.setAttribute('aria-label', 'Alege mărimea');
        var guide = $('a[href*="ghid-marimi"]');
        sheet.innerHTML = '<div class="tpj-grab" aria-hidden="true"></div><div class="tpj-head"><div><strong>Alege mărimea</strong><span></span></div><button type="button" class="tpj-x" aria-label="Închide">' + X + '</button></div><div class="tpj-chips" role="radiogroup" aria-label="Mărimi"></div>' + (guide ? '<a class="tpj-guide" href="' + guide.getAttribute('href') + '">Ghid mărimi</a>' : '') + '<button type="button" class="tpj-cta" disabled>Alege o mărime</button>';
        var t = $('h1', prod); $('.tpj-head span', sheet).textContent = t ? t.textContent.trim().slice(0, 64) : '';
        doc.body.appendChild(sheet);
        $('.tpj-x', sheet).addEventListener('click', function () { closeSheet(); });
        sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
        sheet.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(); });
        $('.tpj-chips', sheet).addEventListener('click', function (e) {
          var c = e.target.closest('.tpj-chip'); if (!c || c.disabled) return;
          var lb = $$('label.tp-option-choice', grp).filter(function (l) { return ($('span', l) || l).textContent.trim() === c.dataset.v; })[0];
          if (lb) { var inp = $('input', lb); inp.click(); }
          $$('.tpj-chip', sheet).forEach(function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
          buzz(10); paint();
        });
        $('.tpj-cta', sheet).addEventListener('click', function () {
          if (!sel || !sel.value) return;
          closeSheet(function () { var st = $('[data-tp-sticky-submit]', prod); bypass = true; if (st) st.click(); setTimeout(function () { bypass = false; }, 400); });
        });
        /* tragere in jos pentru inchidere */
        var sy = null, dy = 0, hd = [$('.tpj-grab', sheet), $('.tpj-head', sheet)];
        hd.forEach(function (h) {
          h.addEventListener('pointerdown', function (e) { if (e.target.closest('.tpj-x')) return; sy = e.clientY; dy = 0; safe(function () { h.setPointerCapture(e.pointerId); }); });
          h.addEventListener('pointermove', function (e) { if (sy == null) return; dy = Math.max(0, e.clientY - sy); sheet.style.transform = 'translateY(' + dy + 'px)'; sheet.style.animation = 'none'; });
          var end = function () { if (sy == null) return; var d = dy; sy = null; sheet.style.transform = ''; sheet.style.animation = ''; if (d > 100) closeSheet(); };
          h.addEventListener('pointerup', end); h.addEventListener('pointercancel', end);
        });
      }
      $('.tpj-chips', sheet).innerHTML = chipsHtml();
      paint();
      root.classList.add('tpj-lock');
      sheet.showModal();
    }
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-tp-sticky-submit]') : null;
      if (!b || bypass || !mobileMQ.matches) return;
      if (sel && sel.value) return;
      if (b.disabled) return;
      e.preventDefault(); e.stopImmediatePropagation();
      openSheet();
    }, true);
    /* daca marimea se alege din pagina cat timp foaia e deschisa, o inchidem */
    form.addEventListener('change', function () { if (sheet && sheet.open && sel && sel.value && !$('.tpj-chip.is-on', sheet)) closeSheet(); });
  });

  /* ====================================================================== */
  /* 3. COS: eliminare animata + "Anuleaza"                                   */
  /* ====================================================================== */
  safe(function () {
    var pending = null, tmr = 0;
    function opener() { return $('[data-tp-cart-open]'); }
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-tp-line][data-tp-quantity="0"]') : null;
      if (!b || b.__tpjGo || b.disabled) return;
      var li = b.closest('.tp-cart-item'); if (!li) return;
      var key = b.dataset.tpLine || '';
      var vid = parseInt(key, 10);
      var qtyEl = $('.tp-quantity span', li);
      var name = ($$('a', li).filter(function (a) { return a.textContent.trim(); })[0] || {}).textContent;
      pending = { vid: vid, qty: Math.max(1, parseInt(qtyEl && qtyEl.textContent, 10) || 1), name: (name || 'Produsul').trim().replace(/\s+/g, ' ') };
      if (reduce) return;
      e.preventDefault(); e.stopImmediatePropagation();
      li.style.maxHeight = li.offsetHeight + 'px';
      void li.offsetHeight;
      li.classList.add('tpj-out');
      setTimeout(function () { b.__tpjGo = 1; b.click(); }, 280);
    }, true);
    /* glisare spre stanga pe telefon = elimina produsul (acelasi traseu ca butonul "Elimina") */
    var sx = 0, sy = 0, sl = null, sdx = 0, slock = null;
    doc.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || !e.target.closest) return;
      var it = e.target.closest('.tp-cart-item');
      if (!it || e.target.closest('button, a, input, select')) return;
      sl = it; sx = e.clientX; sy = e.clientY; sdx = 0; slock = null;
    }, true);
    doc.addEventListener('pointermove', function (e) {
      if (!sl) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (slock === null && (Math.abs(mx) > 9 || Math.abs(my) > 9)) slock = Math.abs(mx) > Math.abs(my) * 1.4 ? 'x' : 'y';
      if (slock !== 'x') return;
      sdx = Math.max(-150, Math.min(0, mx));
      sl.style.transition = 'none'; sl.style.animation = 'none'; sl.style.transform = 'translateX(' + sdx + 'px)';
      var armed = sdx < -92; if (armed !== sl.classList.contains('tpj-armed')) { sl.classList.toggle('tpj-armed', armed); if (armed) buzz(8); }
    }, true);
    function swEnd() {
      if (!sl) return;
      var it = sl, d = sdx, lock = slock; sl = null; sdx = 0; slock = null;
      it.style.transition = ''; it.style.transform = ''; it.style.animation = ''; it.classList.remove('tpj-armed');
      if (lock === 'x' && d < -92) { var rb = $('[data-tp-line][data-tp-quantity="0"]', it); if (rb) rb.click(); }
    }
    doc.addEventListener('pointerup', swEnd, true);
    doc.addEventListener('pointercancel', swEnd, true);
    doc.addEventListener('tp:cart-updated', function () {
      if (!pending) return;
      var p = pending; pending = null;
      var host = $('#tp-cart-content .tp-cart-scroll');
      if (!host || !p.vid) return;
      var old = $('.tpj-undo', host); if (old) old.remove();
      var bar = el('div', 'tpj-undo', '<span></span><button type="button">Anulează</button>');
      $('span', bar).textContent = 'Eliminat: ' + p.name;
      host.insertBefore(bar, host.firstChild);
      clearTimeout(tmr);
      var gone = function () { bar.classList.add('is-leaving'); setTimeout(function () { bar.remove(); }, 320); };
      tmr = setTimeout(gone, 8000);
      $('button', bar).addEventListener('click', function () {
        clearTimeout(tmr); $('button', bar).disabled = true;
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.vid, quantity: p.qty }] }) })
          .then(function (r) { if (!r.ok) throw new Error('x'); buzz(12); var o = opener(); if (o) o.click(); else location.reload(); })
          .catch(function () { bar.querySelector('span').textContent = 'Nu am putut anula. Adaugă produsul din nou.'; });
      });
    });
  });

  /* ====================================================================== */
  /* 4. LEGATURA SPRE PLATA: niciun moment mort intre buton si checkout       */
  /* ====================================================================== */
  safe(function () {
    var o = null, t = 0;
    function hide() { clearTimeout(t); if (o) { safe(function () { o.hidePopover(); }); o.remove(); o = null; } }
    function show() {
      if (o) return;
      o = el('div', 'tpj-go', '<div class="tpj-go__box"><div class="tpj-go__lock">' + LOCK + '</div><strong>Te ducem la plata securizată</strong><p>Datele tale sunt protejate. Durează doar câteva secunde.</p><div class="tpj-go__bar" aria-hidden="true"></div><div class="tpj-go__chips"><i>Plată la livrare sau card</i><i>Retur în 14 zile</i></div></div>');
      o.setAttribute('popover', 'manual'); o.setAttribute('role', 'status'); o.setAttribute('aria-live', 'polite');
      var host = $('dialog:modal') || doc.body;
      host.appendChild(o);
      safe(function () { o.showPopover(); });
      t = setTimeout(hide, 15000);
    }
    if (window.navigation && navigation.addEventListener) {
      navigation.addEventListener('navigate', function (e) {
        safe(function () {
          var d = new URL(e.destination.url);
          if (d.origin !== location.origin) return;
          var isCheckout = /^\/checkouts?(\/|$)/.test(d.pathname) || (e.formData && e.formData.has && e.formData.has('checkout'));
          if (isCheckout && e.navigationType !== 'traverse') show();
        });
      });
    } else {
      doc.addEventListener('submit', function (e) {
        var f = e.target, sub = e.submitter;
        if (!(sub && sub.name === 'checkout')) return;
        setTimeout(function () { if (!e.defaultPrevented) show(); }, 0);
      });
    }
    window.addEventListener('pageshow', hide);
    window.addEventListener('pagehide', function () { if (o) o.style.opacity = '1'; });
  });

  /* ====================================================================== */
  /* 5. VAZUTE RECENT                                                         */
  /* ====================================================================== */
  safe(function () {
    var KEY = 'tp_rv_v1';
    function read() { try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    var prod = $('[data-tp-product]');
    if (prod) {
      var rec = function () {
        var h = handleOf(prod.getAttribute('data-tp-product-url') || location.pathname);
        var t = $('h1', prod), img = $('.tp-pdp-slide img', doc), pr = $('[data-tp-price]', prod);
        if (!h || !t || !img) return;
        var src = img.currentSrc || img.src; if (!src) return;
        var u = new URL(src, location.href); u.searchParams.set('width', '360'); u.searchParams.delete('height');
        var item = { h: h, t: t.textContent.trim().replace(/\s+/g, ' ').slice(0, 90), i: u.pathname + u.search, p: pr ? pr.textContent.replace(/\s+/g, ' ').trim().slice(0, 24) : '' };
        var a = read().filter(function (x) { return x.h !== h; }); a.unshift(item); write(a.slice(0, 14));
      };
      setTimeout(rec, 1500);
    }
    function build(solo) {
      var a = read(); var here = prod ? handleOf(prod.getAttribute('data-tp-product-url') || location.pathname) : null;
      a = a.filter(function (x) { return x.h !== here; });
      if (a.length < 2 && !(solo && a.length)) return null;
      var s = el('section', 'tpj-recent' + (solo ? ' tpj-recent--solo' : ''));
      s.setAttribute('aria-label', 'Văzute recent');
      s.innerHTML = '<div class="tpj-recent__in"><div class="tpj-recent__head"><h2>Continuă de unde ai rămas</h2><button type="button">Șterge</button></div><div class="tpj-recent__rail"></div></div>';
      var rail = $('.tpj-recent__rail', s);
      a.slice(0, 12).forEach(function (x) {
        var c = el('a', 'tpj-rc'); c.href = '/products/' + encodeURIComponent(x.h);
        var im = new Image(); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.width = 300; im.height = 300; im.src = x.i;
        var w = el('div', 'tpj-rc__img'); w.appendChild(im); c.appendChild(w);
        var t = el('div', 'tpj-rc__t'); t.textContent = x.t; c.appendChild(t);
        var p = el('div', 'tpj-rc__p'); p.textContent = x.p; c.appendChild(p);
        rail.appendChild(c);
      });
      $('button', s).addEventListener('click', function () { write([]); s.style.transition = 'opacity .3s, transform .3s'; s.style.opacity = '0'; s.style.transform = 'translateY(8px)'; setTimeout(function () { s.remove(); }, 320); });
      return s;
    }
    function place() {
      var hero = $('.tp-home > .tp-hero');
      if (hero) { var hb = hero.getBoundingClientRect(); if (hb.bottom < innerHeight + 40) return; var s = build(false); if (s) hero.insertAdjacentElement('afterend', s); return; }
      var empty = $('.cart__empty-text');
      if (empty) { var sec = empty.closest('.shopify-section') || empty.parentElement; var s2 = build(true); if (s2 && sec) sec.insertAdjacentElement('afterend', s2); return; }
      var shortcuts = location.pathname === '/search' && !/[?&]q=./.test(location.search) ? $('.tp-shortcuts') : null;
      if (shortcuts) { var s4 = build(true); if (s4) shortcuts.insertAdjacentElement('afterend', s4); return; }
      var nf = $('.tp-404, [data-tp-404]');
      if (nf) { var s3 = build(true); if (s3) nf.insertAdjacentElement('afterend', s3); }
    }
    place();
  });

  /* ====================================================================== */
  /* 6. INTOARCERE PE COLECTIE: cardul deschis pulseaza o data                */
  /* ====================================================================== */
  safe(function () {
    var K = 'tpj_last';
    doc.addEventListener('pointerdown', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.tp-app-card a[href*="/products/"]') : null;
      if (!a) return;
      var h = handleOf(a.getAttribute('href'));
      if (h) safe(function () { sessionStorage.setItem(K, JSON.stringify({ u: location.pathname + location.search, h: h })); });
    }, true);
    function ping() {
      var v = safe(function () { return JSON.parse(sessionStorage.getItem(K) || 'null'); });
      if (!v || v.u !== location.pathname + location.search) return;
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!(nav && nav.type === 'back_forward')) return;
      var card = $$('.tp-app-card').filter(function (c) { var a = $('a[href*="/products/"]', c); return a && handleOf(a.getAttribute('href')) === v.h; })[0];
      if (!card) return;
      var r = card.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) card.scrollIntoView({ block: 'center' });
      card.classList.add('tpj-ping'); setTimeout(function () { card.classList.remove('tpj-ping'); }, 1700);
      safe(function () { sessionStorage.removeItem(K); });
    }
    ping(); window.addEventListener('pageshow', function (e) { if (e.persisted) ping(); });
  });

  /* ====================================================================== */
  /* 7. FILTRARE ANIMATA: cardurile comune se muta la locul nou (View Transitions) */
  /* ====================================================================== */
  safe(function () {
    if (!doc.startViewTransition || reduce) return;
    var orig = Element.prototype.replaceWith;
    function cardHandle(c) { var a = $('a[href*="/products/"]', c); return a ? handleOf(a.getAttribute('href')) : null; }
    Element.prototype.replaceWith = function () {
      var self = this, args = arguments;
      if (!(self.hasAttribute && self.hasAttribute('data-tp-collection')) || !args[0] || !args[0].nodeType || args.length !== 1) return orig.apply(self, args);
      var names = {}, repl = args[0], vt;
      try {
        var vh = innerHeight;
        $$('.tp-app-card', self).slice(0, 80).forEach(function (c) {
          var r = c.getBoundingClientRect(); if (r.bottom < -80 || r.top > vh + 80) return;
          var h = cardHandle(c); if (!h) return; var n = 'tpj' + hash(h); if (names[n]) return;
          names[n] = 1; c.style.viewTransitionName = n; c.style.viewTransitionClass = 'tpjc';
        });
        vt = doc.startViewTransition({
          update: function () {
            orig.apply(self, args);
            $$('.tp-app-card', repl).slice(0, 90).forEach(function (c) {
              var h = cardHandle(c); if (!h) return; var n = 'tpj' + hash(h);
              if (names[n]) { c.style.viewTransitionName = n; c.style.viewTransitionClass = 'tpjc'; }
            });
          },
          types: ['tpj-filter']
        });
        var clean = function () { $$('.tp-app-card[style*="view-transition"]').forEach(function (c) { c.style.viewTransitionName = ''; c.style.viewTransitionClass = ''; }); };
        vt.finished.then(clean, clean);
      } catch (e) {
        if (!vt) return orig.apply(self, args);
      }
    };
  });

  /* ====================================================================== */
  /* 8. SUBSOL PLIABIL PE TELEFON                                             */
  /* ====================================================================== */
  safe(function () {
    var blocks = $$('.footer-block').filter(function (b) { return $('.footer-block__heading', b) && $('.footer-block__details-content', b); });
    if (!blocks.length) return;
    function setup() {
      blocks.forEach(function (b, i) {
        var hd = $('.footer-block__heading', b), ct = $('.footer-block__details-content', b);
        if (!mobileMQ.matches) { b.classList.remove('tpj-acc', 'is-open'); ct.style.maxHeight = ''; hd.removeAttribute('role'); hd.removeAttribute('tabindex'); hd.removeAttribute('aria-expanded'); return; }
        if (!b.classList.contains('tpj-acc')) {
          b.classList.add('tpj-acc');
          hd.setAttribute('role', 'button'); hd.setAttribute('tabindex', '0');
          if (!$('.tpj-chev', hd)) hd.appendChild(el('i', 'tpj-chev'));
          var open = /contact/i.test(hd.textContent);
          b.classList.toggle('is-open', open); hd.setAttribute('aria-expanded', open ? 'true' : 'false');
          var toggle = function () {
            var on = !b.classList.contains('is-open');
            b.classList.toggle('is-open', on); hd.setAttribute('aria-expanded', on ? 'true' : 'false');
            ct.style.maxHeight = on ? ct.scrollHeight + 'px' : '0px';
          };
          hd.addEventListener('click', toggle);
          hd.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
        }
        ct.style.maxHeight = b.classList.contains('is-open') ? ct.scrollHeight + 'px' : '0px';
      });
    }
    setup();
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', setup);
  });

  /* ====================================================================== */
  /* 10. DETALII: cautarea se deschide cu tastatura; butonul din "Gaseste perechea ta" pulseaza cand se schimba numarul */
  /* ====================================================================== */
  safe(function () {
    if (location.pathname === '/search' && !/[?&]q=./.test(location.search)) {
      var inp = $('main input[type="search"], main input[name="q"]');
      if (inp) setTimeout(function () { safe(function () { inp.focus({ preventScroll: true }); }); }, 350);
    }
    var cta = $('[data-tps-cta]');
    if (cta && window.MutationObserver) {
      var last = cta.textContent;
      new MutationObserver(function () {
        if (cta.textContent === last) return; last = cta.textContent;
        cta.classList.remove('tpj-bump'); void cta.offsetWidth; cta.classList.add('tpj-bump');
      }).observe(cta, { childList: true, characterData: true, subtree: true });
    }
  });

  /* ====================================================================== */
  /* 11. PAGINA DE PRODUS: bara de cumparare pe desktop, dovada sociala cand produsul nu are recenzii, morph din miniaturile "Alte culori" */
  /* ====================================================================== */
  safe(function () {
    var prod = $('[data-tp-product]');
    if (!prod) return;
    var main = $('[data-tp-main-atc]', prod), desk = window.matchMedia ? matchMedia('(min-width: 768px)') : { matches: true };
    var form = $('[data-tp-product-form]', prod);
    var bar = null, footer = $('footer.footer, footer');
    function build() {
      var img = $('.tp-pdp-slide img', doc), t = $('h1', prod);
      bar = el('div', 'tpj-dsb');
      bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Cumpărare rapidă');
      var th = new Image(); th.alt = ''; th.width = 48; th.height = 48;
      if (img) { var u = new URL(img.currentSrc || img.src, location.href); u.searchParams.set('width', '120'); u.searchParams.delete('height'); th.src = u.href; }
      var ia = el('div', 'tpj-dsb__img'); ia.appendChild(th);
      var tx = el('div', 'tpj-dsb__t', '<strong></strong><span></span>');
      $('strong', tx).textContent = t ? t.textContent.trim() : '';
      var pr = el('b', 'tpj-dsb__p');
      var btn = el('button', 'tpj-dsb__btn'); btn.type = 'button';
      bar.appendChild(ia); bar.appendChild(tx); bar.appendChild(pr); bar.appendChild(btn);
      doc.body.appendChild(bar);
      btn.addEventListener('click', function () { if (main && !main.disabled) main.click(); });
    }
    function sync() {
      if (!bar) return;
      var sp = $('[data-tp-sticky-price]', prod), sz = $('[data-tp-sticky-size]', prod);
      $('.tpj-dsb__p', bar).innerHTML = sp ? sp.innerHTML : '';
      $('.tpj-dsb__t span', bar).textContent = sz ? sz.textContent : '';
      var b = $('.tpj-dsb__btn', bar); b.textContent = main ? main.textContent : 'Adaugă în coș'; b.disabled = !!(main && main.disabled);
    }
    function vis(on) { if (!bar) return; bar.classList.toggle('is-on', on); }
    if (main && 'IntersectionObserver' in window) {
      var pastMain = false, nearFooter = false;
      var upd = function () { if (!desk.matches) { vis(false); return; } if (!bar) build(); sync(); vis(pastMain && !nearFooter); };
      new IntersectionObserver(function (en) { var e = en[0]; pastMain = !e.isIntersecting && e.boundingClientRect.bottom <= 0; upd(); }).observe(main);
      if (footer) new IntersectionObserver(function (en) { nearFooter = en[0].isIntersecting; upd(); }, { rootMargin: '0px 0px 120px 0px' }).observe(footer);
      if (form) form.addEventListener('change', function () { setTimeout(sync, 30); });
      if (desk.addEventListener) desk.addEventListener('change', upd);
    }

    /* dovada sociala: produs fara recenzii -> nota magazinului, cu trimitere la panoul de recenzii */
    var jm = $('#judgeme_product_reviews');
    function proof() {
      if (!jm || $('.tpj-proof')) return true;
      /* 30.10.2026: produs fara recenzii = Judge.me nu se mai incarca (tp-jm-lazy din theme.liquid), deci nu mai asteptam starea lui goala */
      var tj = window.__tpjm, lazyEmpty = !!(tj && tj.rc === 0 && !tj.started);
      if (!lazyEmpty && !$('.jm-no-reviews-state', jm)) return false;
      var open = $('.tpr-open'); var lab = open ? open.getAttribute('aria-label') || '' : '';
      var m = /(\d+[.,]\d+)\s*din\s*5,\s*(\d+)\s*recenzii/i.exec(lab);
      if (!m) return false;
      jm.classList.add('tpj-jm-empty');
      var p = el('div', 'tpj-proof', '<div class="tpj-proof__stars" aria-hidden="true">★★★★★</div><div class="tpj-proof__t"><strong>' + m[1] + ' din 5</strong> <span>pe baza a ' + m[2] + ' recenzii ale clienților noștri</span></div><button type="button" class="tpj-proof__b">Citește recenziile</button><button type="button" class="tpj-proof__w">Scrie prima recenzie despre acest produs</button>');
      jm.insertAdjacentElement('beforebegin', p);
      $('.tpj-proof__b', p).addEventListener('click', function () { var o = $('.tpr-open'); if (o) o.click(); });
      $('.tpj-proof__w', p).addEventListener('click', function () { try { if (window.__tpjm && window.__tpjm.start) window.__tpjm.start(); } catch (e) {} jm.classList.remove('tpj-jm-empty'); p.classList.add('is-gone'); jm.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); });
      return true;
    }
    if (jm && !proof()) {
      var tries = 0, iv = setInterval(function () { if (proof() || ++tries > 40) clearInterval(iv); }, 400);
    }
  });
  safe(function () {
    /* morph din miniatura "Alte culori" si din cardurile clasice (cautare) spre galeria produsului */
    var lastEl = null;
    doc.addEventListener('pointerdown', function (e) { lastEl = e.target && e.target.closest ? e.target.closest('.tp-siblings a, .card-wrapper') : null; }, true);
    window.addEventListener('pageswap', function (e) {
      safe(function () {
        if (!e.viewTransition || !e.activation || !e.activation.entry || !lastEl) return;
        if (!/^\/products\//.test(new URL(e.activation.entry.url).pathname)) return;
        if ($('[style*="tpf-hero"]')) return;
        var img = $('img', lastEl); if (img) img.style.viewTransitionName = 'tpf-hero';
      });
    });
    window.addEventListener('pageshow', function () { $$('.tp-siblings img, .card-wrapper img').forEach(function (i) { i.style.viewTransitionName = ''; }); });
  });

  /* ====================================================================== */
  /* 12. COLECTII (telefon): buton plutitor "Filtre" dupa ce butonul din pagina a iesit din ecran, cu numarul de filtre active */
  /* ====================================================================== */
  safe(function () {
    var hub = $('[data-tp-collection]');
    if (!hub || !mobileMQ.matches) return;
    var fab = null, io = null, curDrawer = null, offscreen = false;
    function drawer() { return $('[data-tp-filter-drawer]'); }
    function count(d) { return d ? $$('[data-tp-filters] input:checked', d).filter(function (i) { return !/availability/.test(i.name); }).length : 0; }
    function ensure() {
      if (fab) return fab;
      fab = el('button', 'tpj-fab', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></svg><span>Filtre</span><i hidden></i>');
      fab.type = 'button'; fab.setAttribute('aria-label', 'Deschide filtrele');
      doc.body.appendChild(fab);
      fab.addEventListener('click', function () { var d = drawer(); var s = d && $('summary', d); if (s) { buzz(8); s.click(); } });
      return fab;
    }
    function paint() {
      if (!fab) return;
      var d = drawer(); var n = count(d); var b = $('i', fab);
      b.hidden = n === 0; b.textContent = String(n);
      fab.classList.toggle('is-on', offscreen && !(d && d.open) && !root.classList.contains('tp-cart-is-open'));
    }
    function watch() {
      var d = drawer(); if (!d) return;
      var s = $('summary', d); if (!s) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (en) { var e = en[0]; offscreen = !e.isIntersecting && e.boundingClientRect.bottom < 0; ensure(); paint(); }, { rootMargin: '-8px 0px 0px 0px' });
      io.observe(s); curDrawer = d;
      d.addEventListener('toggle', paint);
    }
    watch();
    /* grila se inlocuieste prin AJAX: reluam observatia cand apare un drawer nou */
    new MutationObserver(function () { var d = drawer(); if (d && d !== curDrawer) { watch(); setTimeout(paint, 60); } }).observe(hub.parentElement || doc.body, { childList: true, subtree: true });
    doc.addEventListener('change', function () { setTimeout(paint, 700); });
    doc.addEventListener('tp:cart-updated', paint);
  });

  /* ====================================================================== */
  /* 13. STOC REAL: "Ultima pereche / Mai sunt N perechi" in marimea aleasa (doar cand stocul din Shopify e 1-3), punct pe marimile cu o singura pereche */
  /* ====================================================================== */
  safe(function () {
    var prod = $('[data-tp-product]');
    if (!prod) return;
    var node = $('[data-tp-product-data]', prod); if (!node) return;
    var data = JSON.parse(node.textContent); var vs = data.variants || [];
    if (!vs.length || !vs.some(function (v) { return typeof v.stock === 'number'; })) return;
    var si = Number(prod.dataset.tpSizeIndex); if (!(si >= 0)) return;
    var grp = $('[data-tp-option-index="' + si + '"]', prod); var form = $('[data-tp-product-form]', prod);
    var sel = $('[data-tp-native-variants]', prod);
    if (!grp || !form) return;
    function colorIdx() { var g = $$('[data-tp-option-index]', prod).filter(function (x) { return Number(x.dataset.tpOptionIndex) !== si; })[0]; return g ? Number(g.dataset.tpOptionIndex) : -1; }
    var ci = colorIdx();
    function curColor() { if (ci < 0) return null; var g = $('[data-tp-option-index="' + ci + '"] input:checked', prod); return g ? g.value : null; }
    function stockFor(sizeVal) {
      var c = curColor();
      var v = vs.filter(function (x) { return x.options[si] === sizeVal && (ci < 0 || c == null || x.options[ci] === c); })[0];
      return v && v.available && typeof v.stock === 'number' ? v.stock : null;
    }
    var note = el('div', 'tpj-stock'); note.setAttribute('aria-live', 'polite'); note.hidden = true;
    var area = $('.tp-option-area', prod) || grp.parentElement; area.appendChild(note);
    function mark() {
      var labs = $$('label.tp-option-choice', grp), n = 0, last = 0, flags = [];
      labs.forEach(function (lb) { var s = stockFor(($('span', lb) || lb).textContent.trim()); flags.push(s === 1); if (s != null && s >= 1) n++; if (s === 1) last++; });
      /* punctele de pe marimi apar doar cand diferentiaza: daca aproape toate sunt "ultima pereche", ar fi zgomot */
      var useDots = n > 0 && last / n <= 0.7;
      labs.forEach(function (lb, i) { lb.classList.toggle('tpj-last', useDots && flags[i]); });
    }
    function paint() {
      mark();
      var chk = $('input:checked', grp); var v = chk ? chk.value : null; var s = v ? stockFor(v) : null;
      if (s == null || s < 1 || s > 3) { note.hidden = true; return; }
      note.hidden = false;
      note.innerHTML = '<i aria-hidden="true"></i><span></span>';
      $('span', note).textContent = s === 1 ? 'Ultima pereche în mărimea ' + v : 'Mai sunt doar ' + s + ' perechi în mărimea ' + v;
      note.classList.remove('is-pop'); void note.offsetWidth; note.classList.add('is-pop');
    }
    form.addEventListener('change', function () { setTimeout(paint, 20); });
    paint();
  });

  /* ====================================================================== */
  /* 9. FARA INTERNET                                                         */
  /* ====================================================================== */
  safe(function () {
    var n = null, t = 0;
    function say(msg, ms) {
      if (!n) { n = el('div', 'tpj-net'); n.setAttribute('role', 'status'); doc.body.appendChild(n); }
      n.textContent = msg; void n.offsetWidth; n.classList.add('is-on');
      clearTimeout(t); if (ms) t = setTimeout(function () { n.classList.remove('is-on'); }, ms);
    }
    window.addEventListener('offline', function () { say('Nu ai internet. Coșul și favoritele rămân salvate.', 0); });
    window.addEventListener('online', function () { say('Ai revenit online.', 2200); });
  });

  root.classList.add('tpj-on');
  }

  function cssReady() { try { return getComputedStyle(root).getPropertyValue('--tpj').trim() === '1'; } catch (e) { return true; } }
  function boot() {
    var tries = 0;
    (function poll() { if (cssReady() || ++tries > 50) (window.requestIdleCallback || setTimeout)(start); else setTimeout(poll, 80); })();
  }
  if (doc.readyState === 'complete') boot(); else window.addEventListener('load', boot, { once: true });
})();
